module.exports = __webpack_public_path__ + "img/城市相框-3.fbe99de9.jpg";